import List, { type ListProps } from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import type { UndecoratedPractice } from '@witmetrics/utils';
import { classes, styles } from './utils';

export interface PracticesListProps extends Omit<ListProps, 'onSelect'> {
  practices?: UndecoratedPractice[];
  onSelect: (practiceId: number) => void;
}

export default function PracticesList({
  practices = [],
  onSelect,
  ...props
}: PracticesListProps) {
  return (
    <List {...props}>
      {practices.map((practice) => (
        <ListItem key={practice.id} disablePadding>
          <ListItemButton
            sx={styles.listItemButton}
            className={classes.listItemButton}
            onClick={() => onSelect(practice.id)}>
            <ListItemText primary={practice.name} />
          </ListItemButton>
        </ListItem>
      ))}
    </List>
  );
}
